module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<thead>\n    <th>Experience</th>\n    <th>Last Updated</th>\n</thead>\n<tbody></tbody>\n<tfoot>\n    <tr>\n        <td colspan="2" class="experiences-loading" style="position:relative;"></td>\n    </tr>\n</tfoot>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/imageLibrary/ImageExperienceCompositeView.tpl
// module id = 2857
// module chunks = 0